import { ICON__rows3 } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';
import { LOCAL__ui_generation_set_hovered_button_grid2d_dimension } from '@/state/ui/generation/LOCAL__ui_generation_set_hovered_button_grid2d_dimension';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { useState } from 'react';

interface PROPS {
  field: FIELD__base;
}

export function G_BUTTON__field_use_as_grid2d_row({ field }: PROPS) {
  /*
   * STORE
   */

  const dispatch = use_dispatch();

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * STATE
   */

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EFFECTS
   */

  //todo: mb need move to watcher and refresh pn generation update
  use_effect(() => void dispatch(LOCAL__ui_generation_set_hovered_button_grid2d_dimension()));

  /*
   * EVENTS
   */
  function onMouseEnter() {
    dispatch(LOCAL__ui_generation_set_hovered_button_grid2d_dimension({ g_hovered_grid2d_row: field, g_hovered_grid2d_dimension_from_grid: false }));
  }

  function onMouseLeave() {
    dispatch(LOCAL__ui_generation_set_hovered_button_grid2d_dimension());
  }

  async function onClick() {
    let graph_new = generation_current.tool.graph.clone();
    graph_new.grid2d__use_as_row(field.meta.field_id);

    set_is_loading(true);

    await UTILS__graph_data.update(graph_new);

    set_is_loading(false);
  }

  function is_disabled() {
    return g_general__ui_disabled || is_loading || field.meta.grid2d__is_row || field.meta.ui__is_readonly;
  }

  /*
   * METHODS
   */

  /*
   * HTML
   */

  if (!field.meta.grid2d__can_be_dimension) return <PLACEHOLDER_BUTTON__bar_8_5 />;
  if (field.meta.kind__is_output) return <PLACEHOLDER_BUTTON__bar_8_5 />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_BUTTON__bar_8_5 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="8-5"
      {...{ onClick, onMouseEnter, onMouseLeave }}
      disabled={is_disabled()}
      className=""
      iconClassNameBase="size-3 text-component-item-foreground"
      iconClassNameHovered=""
      Icon={ICON__rows3}
    />
  );
}
